import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, Link } from "react-router-dom";
import {
  setLoading,
  setUsers,
  addUser,
  setEditingUserId,
  //updateUser,
  deleteUser,
  setError,
  setEditingUser,
} from "../../../features/common/userSlice";
import {
  getUserById,
  registerUser,
  updateUser,
} from "../../../services/userservice";

const AddUser = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, editingUserId } = useSelector((state) => state.user);
  const editingUser = useSelector((state) => state.user.editingUser);
  const [isEditMode, setIsEditMode] = useState(false);
  const [dob, setDOB] = useState(null);
  const [formData, setFormData] = useState([
    {
      firstName: "",
      middleName: "",
      lastName: "",
      email: "",
      phone_no: "",
      country: "",
      state: "",
      city: null,
      address: null,
      password: "",
      gender: "",
      dob: "",
      user_type: "",
    },
  ]);

  useEffect(() => {
    if (id && id !== "add" && editingUserId !== id) {
      dispatch(setEditingUserId(id));
      dispatch(setEditingUser(id));
      setIsEditMode(true);
      fetchUserData(id);
    }
  }, [id, editingUserId, dispatch]);

  const fetchUserData = async (id) => {
    try {
      dispatch(setLoading());
      const response = await getUserById(id);
      console.log("response++++++++", response)
      if (response) {
        // Update form data with fetched coupon data
        const responseData = response;
        setFormData({
          firstName: responseData?.firstName,
          middleName: responseData?.middleName,
          lastName: responseData?.lastName,
          email: responseData?.email,
          phone_no: responseData?.phone_no,
          country: responseData?.country,
          state: responseData?.state,
          city: responseData?.city,
          address: responseData?.address,
          password: responseData?.password,
          gender: responseData?.gender,
          dob: responseData?.dob,
          user_type: responseData?.user_type,
          status: responseData?.status,
        });
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoading(false)); // Set loading to false after data is fetched or on error
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      dispatch(setLoading());
      const response =
        id && id !== "add"
          ? await updateUser(id, formData)
          : await registerUser(formData);

      if (response) {
        navigate("/user-list");
      }
    } catch (error) {
      dispatch(setError(error.message));
      alert(error.message);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleDateChange = (name, date) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: date,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Add Users </h1>
            </div>
            {/* /.col */}
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item active">Users</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div classname="row">
            <div classname="col-md-12">
              <form onSubmit={handleSubmit}>
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">First Name</label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputEmail1"
                            placeholder="Enter First Name"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">Middle Name</label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputEmail1"
                            placeholder="Enter Middle Name"
                            name="middleName"
                            value={formData.middleName}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label htmlFor="exampleInputEmail1">Last Name</label>
                          <input
                            type="text"
                            className="form-control"
                            id="exampleInputLastname"
                            placeholder="Enter last Name"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Select Users Type</label>
                          <select
                            className="form-control"
                            id="user_type"
                            name="user_type" // Add name attribute for user_type
                            value={formData.user_type}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            <option value="ADMIN">ADMIN</option>
                            <option value="USER">USER</option>
                            <option value="ACCOUNT">ACCOUNT</option>
                            <option value="MANAGER">MANAGER</option>
                            <option value="SEO">SEO</option>
                            <option value="SUPPORT">SUPPORT</option>
                            <option value="BUSINESS_ANALYST">BUSINESS ANALYST</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label> Email</label>
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            name="email"
                            placeholder="Enter Email"
                            value={formData.email}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label> Password</label>
                          <input
                            type="password"
                            className="form-control"
                            id="password"
                            name="password"
                            placeholder="Enter Password"
                            value={formData.password}
                            onChange={handleInputChange}
                            disabled={isEditMode}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>DOB</label>
                          <DatePicker
                            selected={formData.dob}
                            onChange={(date) => handleDateChange("dob", date)}
                            placeholderText="Select valid from date"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>Select Gender</label>
                          <select
                            className="form-control"
                            id="gender"
                            name="gender"
                            value={formData.gender}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Others">Others</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label>Status</label>
                          <select
                            className="form-control"
                            id="status"
                            name="status"
                            value={formData.status}
                            onChange={handleInputChange}
                          >
                            <option value="">Select</option>
                            <option value="active">ACTIVE</option>
                            <option value="inactive">INACTIVE</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label> Phone Number</label>
                          <input
                            type="text"
                            className="form-control"
                            id="phone_no"
                            name="phone_no"
                            placeholder="Enter phone no"
                            value={formData.phone_no}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label> Country</label>
                          <input
                            type="text"
                            className="form-control"
                            id="country"
                            name="country"
                            placeholder="Enter country"
                            value={formData.country}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label> State</label>
                          <input
                            type="text"
                            className="form-control"
                            id="state"
                            name="state"
                            placeholder="Enter state"
                            value={formData.state}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label> City</label>
                          <input
                            type="text"
                            className="form-control"
                            id="city"
                            name="city"
                            placeholder="Enter City"
                            value={formData.city}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>

                    {/* <div className="form-group">
                    <label>Address</label>
                    <textarea
                      className="form-control"
                      id="address"
                      name="address"
                      rows="3"
                      placeholder="Enter Address..."
                      value={formData.address}
                      onChange={handleInputChange}
                    ></textarea>
                  </div> */}
                  </div>
                  <div className="card-footer">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div></div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AddUser;
